import { useBranding } from 'utils/useBranding'
import { Fileprops } from 'utils/models/File'
import { IMAGE_BASEURL } from 'utils/constants/sections'

// PreviewImage component following ImageDragAndDrop logic convention
const PreviewImage = ({
  imageFile,
  imageExist,
  deleteStatus,
}: {
  imageFile: Fileprops | null
  imageExist: string | null | undefined
  deleteStatus: boolean
}) => {
  const brandingImageExist = imageExist !== '' && imageExist !== null

  // Don't show image if it was deleted
  if (deleteStatus && !imageFile) {
    return null
  }

  // Show new uploaded file
  if (imageFile !== null) {
    return (
      <img
        className="object-cover object-center w-full h-full rounded-tl-80"
        src={URL.createObjectURL(imageFile as Blob)}
        alt="Banner preview"
      />
    )
  }

  // Show existing image from platform setting
  if (imageFile === null && brandingImageExist) {
    return (
      <img
        className="object-cover object-center w-full h-full rounded-tl-80"
        src={IMAGE_BASEURL + imageExist}
        alt="Banner preview"
      />
    )
  }

  // Default placeholder image when no image exists
  return (
    <img
      className="object-cover object-center w-full h-full rounded-tl-80"
      src="https://plus.unsplash.com/premium_photo-1664372145591-f7cc308ff5da?q=80&w=1296&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      alt="Banner preview"
    />
  )
}

const BannerPreview = ({
  bannerTitle,
  bannerSubTitle,
  bannerCallToActionText,
  bannerCallToActionUrl,
  bannerImageFile,
  bannerImageExist,
  bannerImageDeleteStatus,
}: {
  bannerTitle?: string
  bannerSubTitle?: string
  bannerCallToActionText?: string
  bannerCallToActionUrl?: string
  bannerImageFile?: Fileprops | null
  bannerImageExist?: string | null | undefined
  bannerImageDeleteStatus?: boolean
}) => {
  const { branding } = useBranding()

  return (
    <div
      className="pb-16 px-4 relative shadow-lg overflow-hidden drop-shadow-4xl"
      style={{
        backgroundColor: branding.stylingPrimary || '#3b82f6',
      }}
    >
      <div className="bg-white min-h-400 lg:text-left max-w-1400 lg:px-24 pt-6 py-8 relative grid lg:grid-cols-12 lg:gap-12 mx-auto items-center">
        <div className="relative w-full self-center grid-col-span-8">
          <h1
            className="mb-8 pt-0 tracking-tight text-44 mt-0"
            style={{
              color: branding.stylingPrimary || '#3b82f6',
            }}
          >
            {bannerTitle || 'Sample Banner Title'}
          </h1>
          <p className="mb-8 text-18-medium w-85 text-212121">
            {bannerSubTitle ||
              'This is a sample subtitle that describes what your banner section will contain when it goes live.'}
          </p>
          {(bannerCallToActionText || bannerCallToActionUrl) && (
            <span
              className="inline-flex mt-3 mb-0 text-212121 font-bold text-18 py-2-5 px-5 border-radius-5 text-center"
              style={{
                backgroundColor: branding.stylingSecondary || '#10b981',
              }}
            >
              {bannerCallToActionText || 'Call to Action'}
            </span>
          )}
        </div>
        <div className="absolute right-negative-60 top-10 w-55 h-480 rounded-tl-80 overflow-hidden">
          <PreviewImage
            imageFile={bannerImageFile || null}
            imageExist={bannerImageExist}
            deleteStatus={bannerImageDeleteStatus || false}
          />
        </div>
      </div>
    </div>
  )
}

export default BannerPreview
